import { MutableRefObject, useRef, useState } from "react";

/**
 * A custom hook designed for scenarios where you need to prevent stale states in asynchronous operations.
 *
 * @param {any} value - The initial value to store in the reference.
 * @returns {Array} An array containing two elements:
 *   - ref {Object} - A mutable reference object that holds the latest state value.
 *   - updateState {Function} - A function to update the stored state value in the reference.
 *     When called, it replaces the current state with the provided value.
 */
export function useAsyncReference<T>(value: T): [MutableRefObject<T>, (newState: any) => void] {
  const ref = useRef(value);
  const [, forceRender] = useState(false);

  function updateState(newState: T) {
    ref.current = newState;
    forceRender(s => !s);
  }

  return [ref, updateState];
}
